import ApiBase from '../api-base'

export default class Roles extends ApiBase {
  constructor(store) {
    const path = 'org/{orgId}/roles'
    super(path, store)
  }
}
